import DepotAPI from "../api/depot.js";

export const depots = {
  state: {
    depots: [],
    depot: null
  },
  actions: {
    loadAllDepots({ commit }) {
      DepotAPI.getAllDepots().then(res => {
        commit("setDepots", res.data);
      });
    },
    assignSelectedDepot({ commit }, depot) {
      commit("setDepot", depot);
    }
  },
  mutations: {
    setDepots(state, depots) {
      state.depots = depots;
      state.depot = depots[0].value;
    },
    setDepot(state, depot) {
      state.depot = depot;
    }
  },
  getters: {
    getDepots(state) {
      return state.depots;
    },
    getDepot(state) {
      return state.depot;
    }
  }
};
